import { FileDown, X } from "lucide-react";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { sharedExportarPdf } from "../utils/shared-functions";

export default function ProductosModal({
    visible = false,
    items = [],
    onClose,
    tieneDetalleProductos = false,
    numeroDocumento = "",
}) {
    const { t } = useTranslation();
    const contentRef = useRef(null);

    useEffect(() => {
        if (visible === false) {
            items = [];
            tieneDetalleProductos = false;
        }
    }, [visible]);

    const pdfFileName = numeroDocumento
        ? `productos-${String(numeroDocumento).replace(/[^\w.-]+/g, "-")}`
        : "productos";

    const modalTitle = `${t("label_productos")} - ${numeroDocumento}`;

    const renderProductosTable = () => {
        try {
            if (items.length === 0) {
                return (
                    <p className="text-sm text-gray-500 m-0 leading-relaxed">
                        {t("label_sin_productos")}
                    </p>
                );
            }

            return (
                <div className="border border-gray-200 rounded-lg overflow-hidden">
                    <table className="w-full max-w-full text-sm border-collapse table-fixed">
                        <colgroup>
                            <col style={{ width: "12%" }} />
                            <col style={{ width: "28%" }} />
                            <col style={{ width: "10%" }} />
                            <col style={{ width: "10%" }} />
                            <col style={{ width: "10%" }} />
                            <col style={{ width: "10%" }} />
                            <col style={{ width: "20%" }} />
                        </colgroup>
                        <thead>
                            <tr className="bg-gray-50 text-xs font-semibold text-gray-600 border-b border-gray-200">
                                <th scope="col" className="text-left py-2 px-3 font-semibold">
                                    {t("label_codigo_producto")}
                                </th>
                                <th scope="col" className="text-left py-2 px-3 font-semibold">
                                    {t("label_nombre_producto")}
                                </th>
                                <th scope="col" className="text-left py-2 px-3 font-semibold">
                                    {t("label_unidad_medida")}
                                </th>
                                <th scope="col" className="text-right py-2 px-3 font-semibold">
                                    {t("label_cantidad")}
                                </th>
                                <th scope="col" className="text-right py-2 px-3 font-semibold">
                                    {t("label_peso")}
                                </th>
                                <th scope="col" className="text-right py-2 px-3 font-semibold">
                                    {t("label_volumen")}
                                </th>
                                <th scope="col" className="text-right py-2 px-3 font-semibold">
                                    {t("label_monto")}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((producto) => (
                                <tr
                                    key={producto.idProducto}
                                    className="border-b border-gray-100"
                                >
                                    <td className="py-2 px-3 align-top text-gray-900 break-words leading-normal">
                                        {producto.codigoProducto}
                                    </td>
                                    <td className="py-2 px-3 align-top text-gray-900 break-words leading-normal">
                                        {producto.nombreProducto}
                                    </td>
                                    <td className="py-2 px-3 align-top text-gray-800 whitespace-nowrap leading-normal">
                                        {producto.unidadMedida}
                                    </td>
                                    <td className="py-2 px-3 align-top text-right tabular-nums text-gray-800 whitespace-nowrap leading-normal">
                                        {producto.cantidad}
                                    </td>
                                    <td className="py-2 px-3 align-top text-right tabular-nums text-gray-800 whitespace-nowrap leading-normal">
                                        {producto.peso}
                                    </td>
                                    <td className="py-2 px-3 align-top text-right tabular-nums text-gray-800 whitespace-nowrap leading-normal">
                                        {producto.volumen}
                                    </td>
                                    <td className="py-2 px-3 align-top text-right tabular-nums font-medium text-gray-900 whitespace-nowrap leading-normal">
                                        {producto.monto} {producto.moneda}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            );
        } catch (error) {
            console.log('renderProductosTable error');
            console.log(error);
            return null;
        }
    };

    const renderDetalleProductosTable = () => {
        try {
            if (items.length === 0) {
                return (
                    <p className="text-sm text-gray-500 m-0 leading-relaxed">
                        {t("label_sin_productos")}
                    </p>
                );
            }

            return (
                <div className="border border-gray-200 rounded-lg overflow-hidden">
                    <table className="w-full max-w-full text-sm border-collapse table-fixed">
                        <colgroup>
                            <col style={{ width: "15%" }} />
                            <col style={{ width: "35%" }} />
                            <col style={{ width: "15%" }} />
                            <col style={{ width: "17.5%" }} />
                            <col style={{ width: "17.5%" }} />
                        </colgroup>
                        <thead>
                            <tr className="bg-gray-50 text-xs font-semibold text-gray-600 border-b border-gray-200">
                                <th scope="col" className="text-left py-2 px-3 font-semibold">
                                    {t("label_codigo_producto")}
                                </th>
                                <th scope="col" className="text-left py-2 px-3 font-semibold">
                                    {t("label_nombre_producto")}
                                </th>
                                <th scope="col" className="text-left py-2 px-3 font-semibold">
                                    {t("label_unidad_medida")}
                                </th>
                                <th scope="col" className="text-right py-2 px-3 font-semibold">
                                    {t("label_cantidad_programada")}
                                </th>
                                <th scope="col" className="text-right py-2 px-3 font-semibold">
                                    {t("label_cantidad_entregada")}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((producto) => (
                                <tr
                                    key={producto.idProducto}
                                    className="border-b border-gray-100"
                                >
                                    <td className="py-2 px-3 align-top text-gray-900 break-words leading-normal">
                                        {producto.codigoProducto}
                                    </td>
                                    <td className="py-2 px-3 align-top text-gray-900 break-words leading-normal">
                                        {producto.nombre}
                                    </td>
                                    <td className="py-2 px-3 align-top text-gray-800 whitespace-nowrap leading-normal">
                                        {producto.unidadMedida}
                                    </td>
                                    <td className="py-2 px-3 align-top text-right tabular-nums text-gray-800 whitespace-nowrap leading-normal">
                                        {producto.cantidadProgramada}
                                    </td>
                                    <td className="py-2 px-3 align-top text-right tabular-nums font-medium text-gray-900 whitespace-nowrap leading-normal">
                                        {producto.cantidadEntregada}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            );
        } catch (error) {
            console.log('renderDetalleProductosTable error');
            console.log(error);
            return null;
        }
    };

    if (!visible) return null;

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 p-4">
            <div className="bg-white rounded-lg shadow-xl border border-gray-200 w-full max-w-5xl max-h-[85vh] flex flex-col">
                <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 gap-3 shrink-0">
                    <h3 className="text-lg font-semibold text-gray-900 min-w-0 truncate leading-normal">
                        {/* {modalTitle} */}
                    </h3>
                    <div className="flex items-center gap-2 shrink-0">
                        <button
                            type="button"
                            onClick={() => sharedExportarPdf(contentRef, pdfFileName)}
                            className="flex items-center gap-2 px-3 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg text-sm font-medium"
                        >
                            <FileDown className="h-4 w-4" />
                            {t("label_exportar_pdf")}
                        </button>
                        <button
                            type="button"
                            className="px-3 py-1 text-sm text-gray-600 hover:text-gray-900"
                            onClick={onClose}
                        >
                            <X className="h-5 w-5" />
                        </button>
                    </div>
                </div>
                <div
                    ref={contentRef}
                    className="p-4 overflow-auto bg-white text-black min-h-0"
                    style={{ fontFamily: "sans-serif" }}
                >
                    <div data-pdf-block>
                        <h3 className="text-lg font-semibold text-gray-900 leading-normal mb-3 pb-0.5 m-0">
                            {modalTitle}
                        </h3>
                        {tieneDetalleProductos === false && renderProductosTable()}
                        {tieneDetalleProductos === true && renderDetalleProductosTable()}
                    </div>
                </div>
                <div className="px-4 py-3 border-t border-gray-200 flex justify-end">
                    <button
                        type="button"
                        className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-md text-sm"
                        onClick={onClose}
                    >
                        {t("label_cerrar")}
                    </button>
                </div>
            </div>
        </div>
    );
}
